import type {IProfile} from '../pages/Profile/types';

export function canManageTariff(profile?: IProfile | null): boolean {
    if (!profile) {
        return true;
    }

    if (profile.is_company_owner) {
        return true;
    }

    return profile.tariff === false;
}

export function canLeaveCompany(profile?: IProfile | null): boolean {
    if (!profile) {
        return false;
    }

    return profile.can_leave_company === true;
}
